import React, { memo, useMemo, useState, useRef } from 'react';
import { SectionChart, EditTable } from '@components';
import { EDIT_TABLE_COLUMNS_TYPE } from '@utils/enums';

const Index = ({ projectInfo }) => {
  // demo
  const sectionChartRef = useRef(null);
  const [sourceData, setSourceData] = useState([
    {
      id: 1,
      Category: 'People',
      CompanyA: 'Aaa',
      CompanyB: 'Baa',
      date: '05/15/2023',
    },
    {
      id: 2,
      Category: 'Application',
      CompanyA: 'ccc',
      CompanyB: 'ddd',
      date: '05/18/2023',
    },
  ]); // 从rick那边拿数据

  // 可编辑表格的参数
  const editTableParams = useMemo(
    () => ({
      tableProps: {
        pagination: false,
        rowKey: 'id',
        // scroll: { y: `${window.screen.height - 455}px` }, // 根据自己不同要求控制高度
        // loading: tableLoading, // 获取数据和保存的时候控制表格loading
      },
      tableColumns: [
        {
          title: 'Category',
          dataIndex: 'Category',
          required: true,
          editable: true,
          type: EDIT_TABLE_COLUMNS_TYPE.SELECT,
          compProps: {
            options: [
              { label: 'People', value: 'People' },
              { label: 'Applications', value: 'Applications' },
              { label: 'Legal Entities', value: 'LegalEntities' },
              { label: 'Contracts', value: 'Contracts' },
            ],
          },
        },
        {
          title: 'Company A',
          dataIndex: 'CompanyA',
          required: (record) => record.Category !== 'People',
          editable: true,
          type: EDIT_TABLE_COLUMNS_TYPE.INPUT,
          compProps: {
            disabled: (record) => record.Category === 'People',
          },
        },
        {
          title: 'Company B',
          dataIndex: 'CompanyB',
          required: true,
          editable: true,
          type: EDIT_TABLE_COLUMNS_TYPE.INPUT,
          compProps: {
            disabled: (record) => record.Category === 'People',
          },
        },
        {
          title: 'Test Date',
          dataIndex: 'date',
          required: true,
          editable: true,
          type: EDIT_TABLE_COLUMNS_TYPE.DATE_PICKER,
        },
      ], // 推荐单独写一个index.data.ts文件存放该枚举
      defaultDataSource: sourceData,
      afterAddRowFunc: (newItem) => {
        newItem.Category = 888;
      }, // 添加行增加默认值的demo
      beforeEditRowFunc: (newItem) => {
        if (newItem.Category === 'People') {
          newItem.CompanyA = '';
        }
      },
      afterDeleteRowFunc: (newData) => {
        newData.forEach((item) => (item.CompanyB = ''));
      },
      dataChange: (newData) => console.log('dataChange   ::::', newData),
      saveData: (resData) =>
        console.log('saveData   ::::', JSON.stringify(resData)),
    }),
    [
      projectInfo,
      // tableLoading,
    ],
  );
  const editTableRef = useRef(null);
  return (
    <div style={{ display: 'flex' }}>
      <div style={{ flex: 0.8 }}>
        <EditTable ref={editTableRef} {...editTableParams} />
      </div>
      <SectionChart
        ref={sectionChartRef}
        containerId="123123"
        chartPattern="spider"
        noDataFlag={false}
      />
    </div>
  );
};

export default memo(Index);
